export default "__VITE_ASSET__7c95ef25__"